export const USER_UPDATE_AUTH = "USER_UPDATE_AUTH";
export const USER_UPDATE_UUID = "USER_UPDATE_UUID";
export const USER_UPDATE_NAME = "USER_UPDATE_NAME";
export const USER_UPDATE_EMAIL = "USER_UPDATE_EMAIL";
export const USER_UPDATE_ROLE = "USER_UPDATE_ROLE";
export const USER_UPDATE_NEW = "USER_UPDATE_NEW";
export const USER_UPDATE_REQUESTEDPASSWORD = "USER_UPDATE_REQUESTEDPASSWORD";
export const USER_UPDATE_ORGID = "USER_UPDATE_ORGID";
export const USER_UPDATE_USERDEPARTMENTS = "USER_UPDATE_USERDEPARTMENTS";
export const USER_UPDATE_SAREQUEST = "USER_UPDATE_SAREQUEST";
export const USER_UPDATE_PROFILES = "USER_UPDATE_PROFILES";
export const USER_UPDATE_BOOKINGAPPROVE = "USER_UPDATE_BOOKINGAPPROVE";

export const userUpdateAuth = (val) => {
    return {
        type: USER_UPDATE_AUTH,
        value: val
    };
};

export const userUpdateUUID = (val) => {
    return {
        type: USER_UPDATE_UUID,
        value: val
    };
};

export const userUpdateName = (val) => {
    return {
        type: USER_UPDATE_NAME,
        value: val
    };
};

export const userUpdateEmail = (val) => {
    return {
        type: USER_UPDATE_EMAIL,
        value: val
    };
};

export const userUpdateRole = (val) => {
    return {
        type: USER_UPDATE_ROLE,
        value: val
    };
};

export const userUpdateNew = (val) => {
    return {
        type: USER_UPDATE_NEW,
        value: val
    };
};

export const userUpdateRequestedPassword = (val) => {
    return {
        type: USER_UPDATE_REQUESTEDPASSWORD,
        value: val
    };
};

export const userUpdateOrgID = (val) => {
    return {
        type: USER_UPDATE_ORGID,
        value: val
    };
};

export const userUpdateUserDepartments = (val) => {
    return {
        type: USER_UPDATE_USERDEPARTMENTS,
        value: val
    };
};

export const userUpdateSARequest = (val) => {
    return {
        type: USER_UPDATE_SAREQUEST,
        value: val
    };
};

export const userUpdateProfiles = (val) => {
    return {
        type: USER_UPDATE_PROFILES,
        value: val
    };
};

export const userUpdateBookingApprove = (val) => {
    return {
        type: USER_UPDATE_BOOKINGAPPROVE,
        value: val
    };
};
